export default __webpack_public_path__ + "b48410fe36f28bd2914ab5c569cfe45a.png";